import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import { getModuleValue, useWindowSize } from "../../../../../Helpers";
import BrandLogo from "@components/BrandLogo";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import Button from "@components/Button";
import StickyButton from "@components/StickyButton";
import prizeBg from "@assets/decor.png";
import { useNavigate } from "react-router";
import Floral from "./img/flora-prima.png";
import ActivityPoints from "@components/ActivityPoints";
import DOMPurify from "dompurify";

export default function MazeOutroTemplate({
  data,
  gameQuestionsQuery,
  coupon,
}) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;
  const navigate = useNavigate();

  return (
    <section className="activities-finish-page finish-maze">
      <div>
        <PagesHeader>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(getModuleValue(
                data?.content?.modules,
                "description_success",
                "metadata.title"
              )),
            }}
          ></p>
        </PagesHeader>
        <div className="desktop-wrapper">
          <div className="main-content-wrapper">
            <LinearGradientProgressBar value={1} />
            <div className="game-question">
              {coupon.catalogue ? (
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(getModuleValue(
                      data?.content?.modules,
                      "description_success",
                      "custom"
                    )),
                  }}
                ></p>
              ) : (
                <p className="desc">
                  Du hast den Weg aus dem Labyrinth gefunden!
                </p>
              )}
            </div>
            <div>
              {!coupon.catalogue ? (
                <div className="reward-box">
                  <div className="copy">Du&nbsp;erhältst: </div>
                  <div className="value">
                    <img className="img" src={prizeBg} alt={20} />
                    <div className="prize">
                      <div className="inner">
                        +{20}
                        <span className="prize-copy">Punkte</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="green-box">
                  <img src={Floral} alt="Floral" />
                </div>
              )}
            </div>
            <div className="exhange-cta">
              {coupon.catalogue ? (
                <Button
                  btnClass="yellow outline"
                  href={`/coupons/received/${coupon.coupon}`}
                >
                  Zum Gutschein
                </Button>
              ) : (
                <Button btnClass="yellow outline" href="/coupons">
                  Punkte Eintauschen
                </Button>
              )}
            </div>
          </div>
          <div className="activity-img">
            <div className="activity-image-inner">
              <img
                src={getModuleValue(
                  data?.content?.modules,
                  "hero_image",
                  "file.url"
                )}
                alt={getModuleValue(
                  data?.content?.modules,
                  "hero_image",
                  "metadata.imgDesc"
                )}
                className="mobile-img"
              />
              <img
                src={getModuleValue(
                  data?.content?.modules,
                  "hero_image",
                  "file.url"
                )}
                alt={getModuleValue(
                  data?.content?.modules,
                  "hero_image",
                  "metadata.imgDesc"
                )}
                className="desktop-img"
              />

              <BrandLogo desktopBig brands={data?.brands} />
              {!coupon.catalogue && <ActivityPoints>{20}</ActivityPoints>}
            </div>
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  {coupon.catalogue ? (
                    <Button
                      btnClass="yellow outline"
                      href={`/coupons/received/${coupon.coupon}`}
                    >
                      Zum Gutschein
                    </Button>
                  ) : (
                    <Button btnClass="yellow outline" href="/coupons">
                      Punkte Eintauschen
                    </Button>
                  )}

                  <Button
                    {...(gameQuestionsQuery?.customFinishLink && {
                      action: () => {
                        navigate("/activities");
                      },
                    })}
                    href={
                      gameQuestionsQuery?.customFinishLink
                        ? gameQuestionsQuery?.customFinishLink
                        : "/activities"
                    }
                  >
                    {gameQuestionsQuery?.customFinishButtonCopy
                      ? gameQuestionsQuery?.customFinishButtonCopy
                      : "Zur nächsten Aktivität"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
        {!XGA && (
          <StickyButton
            {...(gameQuestionsQuery?.customFinishLink && {
              action: () => {
                navigate("/activities");
              },
            })}
            href={
              gameQuestionsQuery?.customFinishLink
                ? gameQuestionsQuery?.customFinishLink
                : "/activities"
            }
          >
            {gameQuestionsQuery?.customFinishButtonCopy
              ? gameQuestionsQuery?.customFinishButtonCopy
              : "Zur nächsten Aktivität"}
          </StickyButton>
        )}
      </div>
    </section>
  );
}
